import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../app/hooks';
import { Button } from '../../../components/common/Button/Button';
import { CheckText } from '../../../components/common/CheckText';
import { ULX, formatUSD } from '../../../helpers/helperFunctions';
import { H5, P1, P2, P3 } from '../../../styles/FontStyles';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconWarningMark } from '../../../styles/Icons';
import { ClaimStepsEnum } from './types';
import { UserPackage } from '../Portfolio.types';

interface ClaimWithdrawalProps {
  packageItem: UserPackage | null;
  setClaim: Dispatch<SetStateAction<boolean>>;
  setClaimStep: Dispatch<SetStateAction<ClaimStepsEnum>>;
  amount: string;
}

export const ClaimWithdrawal = ({
  packageItem,
  setClaim,
  setClaimStep,
  amount
}: ClaimWithdrawalProps) => {
  const { t } = useTranslation('my_hubs');
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const [checkbox4, setCheckbox4] = useState(false);

  const { ulxAmountToBurn } = useAppSelector((state) => state.portfolio);

  return (
    <>
      <Box gray>
        <Flexed column>
          <Flexed column center>
            <Icon mb='12'>
              <IconWarningMark size='50' color={color.colors.error500} />
            </Icon>
            <H5 mb='20' color={color.colors.error500}>
              {t('claim.warning')}!
            </H5>
            <P1 mb='20' left bold color={color.colors.neutral500}>
              {t('claim.carefully_review_witdrawal')}
              <br />
            </P1>
            <Box blue>
              <Flexed column>
                <Flexed>
                  <P2 mb='10' mr='5' color={color.colors.neutral500}>
                    {t('claim.amount_unlocked')}
                  </P2>
                  <P2 semiBold>
                    {formatUSD(packageItem?.availableStake)} {ULX}
                  </P2>
                </Flexed>
                <Flexed>
                  <P2 mb='10' mr='5' color={color.colors.neutral500}>
                    {t('claim.amount_to_withdraw')}
                  </P2>
                  <P2 semiBold>
                    {formatUSD(Number(amount))} {ULX}
                  </P2>
                </Flexed>
                <Flexed>
                  <P2 mb='10' mr='5' color={color.colors.error500}>
                    {t('claim.amount_burned_value')}
                  </P2>
                  <P2 semiBold color={color.colors.error500}>
                    {formatUSD(ulxAmountToBurn)} {ULX} 😢
                  </P2>
                </Flexed>
              </Flexed>
            </Box>
          </Flexed>
          <Flexed>
            <P2 mb='20' mt='20' mr='5' bold>
              {t('claim.total_receiving_amount')}
            </P2>
            <P2 bold mt='20'>
              {formatUSD(Number(amount) - ulxAmountToBurn)} {ULX}
            </P2>
          </Flexed>
          <P2 bold color={color.colors.error500}>
            {t('claim.your_withdraw_warning')}
          </P2>
        </Flexed>
      </Box>
      <CheckText
        checked={checkbox1}
        onClick={() => setCheckbox1(!checkbox1)}
        text={t('claim.confirm_txt3')}
        checkColor={color.colors.error500}
      />
      <CheckText
        checked={checkbox2}
        onClick={() => setCheckbox2(!checkbox2)}
        text={t('claim.confirm_txt4')}
        checkColor={color.colors.error500}
      />
      <CheckText
        checked={checkbox3}
        onClick={() => setCheckbox3(!checkbox3)}
        text={t('claim.confirm_txt5')}
        checkColor={color.colors.error500}
      />
      <Flexed>
        <CheckText
          checked={checkbox4}
          onClick={() => setCheckbox4(!checkbox4)}
          checkColor={color.colors.error500}
        />

        <P3 mt='3' semiBold color={color.colors.neutral500}>
          {t('claim.confirm_txt6')}{' '}
          <span style={{ color: color.colors.error500 }}>
            {formatUSD(ulxAmountToBurn)} {ULX}{' '}
          </span>
          {t('claim.confirm_txt7')}
        </P3>
      </Flexed>

      <Flexed>
        <Button
          onClick={() => setClaim(false)}
          mt='20'
          mr='10'
          color={color.colors.success500}>
          {t('claim.cancel_withdrawal')}
        </Button>
        <Button
          onClick={() => {
            setClaimStep(ClaimStepsEnum.FINISH);
          }}
          mt='20'
          ml='10'
          disabled={!checkbox1 || !checkbox2 || !checkbox3 || !checkbox4}
          color={color.colors.error500}>
          {t('claim.continue_to_withdrawal')}
        </Button>
      </Flexed>
    </>
  );
};
